import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartContract = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24 6L42 16V32L24 42L6 32V16L24 6Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M24 6V42M6 16L42 32M42 16L6 32",
		stroke: "currentColor",
		strokeWidth: 1,
		opacity: .25
	})]
});
export default SvgSmartContract;
